module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n      " + _vm._s(_vm.value.first_name) + " " + _vm._s(_vm.value.last_name) + "\n      "), _c('small', [_vm._v("(" + _vm._s(_vm.value.year_of_birth) + ")")])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n      " + _vm._s(_vm.value.email) + "\n    ")])], 1), _vm._v(" "), _vm._t("action")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99c63ff6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/Physitrack/PhysitrackClientListItem.vue
// module id = 1501
// module chunks = 9